module.exports = __webpack_public_path__ + "img/pay-success.6eba03b9.png";